module.exports = __webpack_public_path__ + "static/media/02.5141bc32.wav";